import script from "./componentMain.vue?vue&type=script&lang=ts&setup=true"
export * from "./componentMain.vue?vue&type=script&lang=ts&setup=true"

import "./componentMain.vue?vue&type=style&index=0&id=57a2afef&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a2afef"]])

export default __exports__